import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectSearchQuery = createSelector(
  (state: RootState) => state.search.query,
  query => query
)

export default selectSearchQuery
